<template>
<div>

  <v-expand-transition> 
   {{school}}
    <div  v-if="isSchool()" class="ma-3">
      
  <div class="headline text-color-green">Vissla </div>
  <div class="headline3">Att vissla är något som är bra, det ger möjlighet att anonymt ta upp ett problem som annars hade blivit olyft. 
    Både personen som bär på problemet och skolan som helhet blir bättre och starkare efter en vissling, så våga! </div>

  <p class="title font-weight-bold">Meddelande: </p>
              <v-textarea
          solo
          v-model="message"
          name="input-7-4"
          label="Vad har du på hjärtat?"
        ></v-textarea>   
                    <v-select
                    
                attach
                chips
                multiple
                      :items="membernameandId"
                      label="Vem/vilka vill du skicka till"
                      hint="Det kan vara en eller flera. Den du har mest förtroende för eller den som är mest lämpad för meddelandet."
                      v-model="reciever2"
                      item-text="[2]"
                      item-value="[1]"
                      required
                    ></v-select>
            <v-btn color="green lighten-1"  :disabled="reciever2.length==0"   text dark @click="createWhistle({schoolId: school.id,reciever:reciever2, message: message});reciever2=[];message='';Hide=false;" >
          Vissla in
        </v-btn>
    </div>
    <div v-else>
    <div class="headline">  Ingen skolkod </div>    
    </div>
  </v-expand-transition>

</div>
</template>

<script>
import Home from './Home.vue';
// import classrooms from '../components/classrooms'
import { mapActions, mapGetters } from 'vuex'

export default {
   props: {
    school: Object,
    schoolCode: String,
  },

  updated(){
    //console.log("hej")
this.open();

  },
    data: () => ({
      loaded:false,
      send:false,
      reciever2: [],
      message: "",
      // schoolCode:"",
      oldSchoolcode:"",
      Hide: false,
      change:false,
      // membernameandId: ["Ulla,Kurator","Frank,Skolchef","Roger,Rektor","Lena,SYV"]

  }),

  watch: {
    school: function (val) {
     this.Hide=true;
      this.oldSchoolcode=this.schoolCode
        this.change=true;
    },
  },

  methods: {

    ...mapActions('ehtmembers', ['logoutEHT','initEHT']),
    // ...mapActions('schools', ['getSchool']),
    ...mapActions('whistles', ['createWhistle']),
    open(){
      //console.log(this.Hide)
      if (this.Hide==false) {
        
      if (this.school==null || this.oldSchoolcode!=this.schoolCode) {
        this.logoutEHT();
      this.getSchool(this.schoolCode);
       
      }
      else
      this.Hide=!this.Hide;
      }
      else
      this.Hide=!this.Hide;
    },
    isSchool(){
      
      if (this.school!=null ||  this.change) {
        if (this.change) {
          //console.log(this.school)
         this.initEHT(this.school.id)
           this.change=false
        }
        // else
        // {
          return true
        // }
      }
      return false;

    }
  },
    computed: {
   
    ...mapGetters('ehtmembers', ['membernameandId']),
    
    // ...mapGetters('schools', ['school']),

  },
  components: {
    Home
    // classrooms

  }
}
</script>
<style scoped>
 .centered-input >>> input {
      text-align: center;
      color:green;
       font-size: 2em;

    }
  .place{
          width: 50%;
      margin-right: 25%;
      margin-left: 25%;
  }

</style>
